// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"tc_a bib_rc bib_qx bib_xr","ForumPosts__contest":"tc_b bib_hq","ForumPosts__counselling":"tc_c"};